module.exports = __webpack_public_path__ + "img/45901e964ae07ba405c69cb91f5e52e1.png";